import React, { FunctionComponent, useMemo } from 'react';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { assertNotNullOrUndefined } from 'record-it-utils/utils/assert/assertNotNullOrUndefined';
import {
  CurrentUserContext,
  CurrentUserContextValue
} from '../context/CurrentUserContext';
import { UserPermissions } from '../classes/misc/UserPermissions/UserPermissions';
import { useCurrentUserData } from '../hooks/authentication/useCurrentUserData/useCurrentUserData';
import { useAuth } from '../hooks/useAuth';

export const AppCurrentUserContextProvider: FunctionComponent = React.memo(
  (props) => {
    const { children } = prepareProps({ props });

    const { authenticationData } = useAuth();
    const currentUserData = useCurrentUserData(authenticationData);

    const contextValue = useMemo<CurrentUserContextValue>(() => {
      const currentUserPermissions = currentUserData
        ? new UserPermissions(currentUserData)
        : null;

      return {
        currentUser: currentUserData?.user ?? null,
        getRequiredCurrentUser: () => {
          assertNotNullOrUndefined(
            currentUserData,
            'no currentUserData available'
          );
          return currentUserData.user;
        },
        getRequiredCurrentUserPermissions: () => {
          assertNotNullOrUndefined(
            currentUserPermissions,
            'no currentUserPermissions available'
          );
          return currentUserPermissions;
        }
      };
    }, [currentUserData]);

    return (
      <CurrentUserContext.Provider value={contextValue}>
        {children}
      </CurrentUserContext.Provider>
    );
  }
);
